import {
  UPDATE_PENDING_REQUEST_REQUEST,
  UPDATE_PENDING_REQUEST_SUCCESS,
  UPDATE_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const updatePendingRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PENDING_REQUEST_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_PENDING_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_PENDING_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default updatePendingRequestReducer;
